import React from "react"
import { useDispatch } from "react-redux"
import { PlayCircleFill } from "react-bootstrap-icons"
import { prependAndPlay } from "../../stores/mediaPlayerSlice"
import styles from "./styles.module.css"

export interface HotBitsSongData {
  post_id: number
  title: string
  score: number
  plays: number
  band_id: number
  band_name: string
  band_path: string
  band_cover_image: string | null
  album_id: number | null
  album_name: string | null
  album_path: string | null
  cover_image_small: string | null
  duration: number | null
  local_path: string
  nada_path: string
  streaming_url: string
  post_type: string
}

interface HotBitsAttrs {
  playlistId: number | null
  playlist_name: string
  playlist_path: string | null
}

interface Props {
  song: HotBitsSongData
  rank: number
  hotBitsAttrs: HotBitsAttrs
}

const recordHotBitsPageView = (postId: number) => {
  const csrf = (document.querySelector("meta[name=csrf-token]") as HTMLMetaElement)?.content
  fetch("/api/v1/referral_conversions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(csrf ? { "X-CSRF-Token": csrf } : {}),
    },
    body: JSON.stringify({
      convertible_type: "Post",
      convertible_id: postId,
      conversion_type: "page_view",
    }),
  })
}

const HotBitsSong = ({ song, rank, hotBitsAttrs }: Props) => {
  const dispatch = useDispatch()

  const onPlayClick = () => {
    dispatch(
      prependAndPlay([
        {
          id: song.post_id,
          title: song.title,
          band_id: song.band_id,
          band_name: song.band_name,
          album_id: song.album_id,
          album_name: song.album_name,
          album_path: song.album_path,
          cover_image_small: song.cover_image_small,
          duration: song.duration,
          local_path: song.local_path,
          nada_path: song.nada_path,
          parent_path: song.nada_path,
          streaming_url: song.streaming_url,
          post_type: song.post_type,
          ...hotBitsAttrs,
        },
      ]),
    )
  }

  return (
    <div className={styles.row}>
      <span className={styles.rank}>{rank}</span>
      <div className={styles.songInfo}>
        <a href={song.nada_path} className={styles.title} onClick={() => recordHotBitsPageView(song.post_id)}>{song.title}</a>
        <a href={song.band_path} className={styles.artist} onClick={() => recordHotBitsPageView(song.post_id)}>{song.band_name}</a>
      </div>
      <button
        onClick={onPlayClick}
        aria-label={`Play ${song.title}`}
        className={styles.playButton}
      >
        <PlayCircleFill size={22} />
      </button>
    </div>
  )
}

export default HotBitsSong
